export default "__VITE_ASSET__qRJO5eQ$__"